// Modelos de tela do Mapa Arboreo e da Area Piloto (camelCase), montados a partir da API real.

import type { TreeApi } from "@/lib/api";
import type { InspectionQuadraLink, Quadra } from "@/types/territorial";

/** Exemplar com coordenada, pronto para o mapa. */
export interface TreeMapPoint {
  /** id numerico do exemplar (cta.tree_individuals.id), usado nas rotas /cta/:id. */
  id: number;
  codigoCta: string;
  nomePopular: string;
  nomeCientifico: string;
  speciesId: number | null;
  /** Codigo de individual_type (ARVORE, PALMEIRA...). */
  tipo: string;
  /** Classe de risco da ultima avaliacao (BAIXO..CRITICO) ou "" sem avaliacao. */
  classeRisco: string;
  statusRevisao: string;
  bairro: string;
  logradouro: string;
  projeto: string;
  projectId: number | null;
  latitude: number;
  longitude: number;
  ultimaVistoria: string | null;
  ultimaVistoriaId: number | null;
}

export interface MapLayer {
  id: string;
  nome: string;
  icone: string;
  cor: string;
  ativa: boolean;
  categoria: "individuos" | "territorio" | "referencia";
  descricao?: string;
}

/** Converte a linha da API; exemplar sem coordenada nao vai para o mapa. */
export function toTreeMapPoint(t: TreeApi): TreeMapPoint | null {
  if (t.latitude == null || t.longitude == null) return null;
  return {
    id: t.id,
    codigoCta: t.cta_code ?? "",
    nomePopular: t.species_popular_name ?? "",
    nomeCientifico: t.species_scientific_name ?? "",
    speciesId: t.species_id,
    tipo: t.individual_type ?? "",
    classeRisco: (t.latest_risk_class ?? "").toUpperCase(),
    statusRevisao: t.review_status ?? "",
    bairro: t.neighborhood ?? "",
    logradouro: t.street ?? "",
    projeto: t.project_name ?? "",
    projectId: t.project_id,
    latitude: t.latitude,
    longitude: t.longitude,
    ultimaVistoria: t.latest_inspection_date,
    ultimaVistoriaId: t.latest_inspection_id,
  };
}

/** Quadra operacional com a inspecao territorial (FITA) mais recente vinculada a ela, se houver. */
export interface QuadraComAnalise {
  quadra: Quadra;
  analise: InspectionQuadraLink | null;
}
